import { api, buildQuery } from "./client";
import type { CreateUserInput } from "@academichub/shared";
import type { PageResult, UserSummary } from "./types";

/** Daftar pengguna ter-scope, pembuatan akun, dan keputusan pendaftaran. */

export type UserListStatus = "ALL" | "PENDING" | "APPROVED" | "REJECTED";

export interface UserListParams {
  page?: number;
  perPage?: number;
  role?: string;
  /** Bawaannya hanya akun APPROVED; menu Kelola Pengguna memakai ALL/PENDING. */
  status?: UserListStatus;
  q?: string;
}

export function listUsers(params: UserListParams = {}) {
  return api.get<PageResult<UserSummary>>(`/users${buildQuery({ ...params })}`);
}

export function createUser(input: CreateUserInput) {
  return api.post<UserSummary>("/users", input);
}

export function approveUser(userId: string) {
  return api.post<UserSummary>(`/users/${userId}/approve`);
}

export function rejectUser(userId: string, reason: string) {
  return api.post<UserSummary>(`/users/${userId}/reject`, { reason });
}
